import React from 'react';
import clsx from 'clsx';
import { styled, theme } from '@components-shared/src/stitches';

export const Background = ({
  coverImage,
  fadeStyle = 'darkFade',
  rounded = false,
}: {
  coverImage?: string;
  fadeStyle?: 'lightFade' | 'darkFade';
  rounded?: boolean;
}) => {
  return (
    <>
      {/* To ensure that the border radius of the cover image is visually applied, we require a wrapper div on the cover with the image.
      This is because the cover image is blurred and scaled, which causes the border radius to not be visually applied.
    */}
      <div
        className={clsx(
          'absolute h-full w-full transform-gpu ',
          rounded && 'overflow-hidden rounded-md',
        )}
      >
        <Cover
          css={{
            position: 'unset',
            background: !!coverImage ? `url('${coverImage}')` : '#fff',
            // Background size needs to come after background for it to work in some browsers
            // For this reason, the below code can't be moved to a variant
            // https://stackoverflow.com/questions/26236486/background-size-cover-not-working
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            transform: 'translateZ(0)',
          }}
          image
        />
      </div>
      <Cover className={clsx(rounded && ' transform-gpu rounded-md')} style={fadeStyle} />
      <Cover className={clsx(rounded && ' transform-gpu rounded-md')} style="blur" />
    </>
  );
};

const Cover = styled('div', {
  position: 'absolute',
  height: '100%',
  width: '100%',
  transform: theme.scales.imageZoom,

  left: 0,
  top: 0,

  variants: {
    style: {
      lightFade: {
        background: 'rgba(0, 0, 0, 0.3)',
      },
      darkFade: {
        background: 'rgba(0, 0, 0, 0.5)',
      },
      blur: {
        background: 'rgba(217, 217, 217, 0.01)',
      },
    },
    image: {
      true: {
        filter: 'blur(40px)',
        // Fix safari mobile bug causing background to be appear gray
        // https://stackoverflow.com/questions/70138527/css-filter-blur-not-working-properly-on-safari
        '-webkit-backface-visibility': 'hidden',
        '-moz-backface-visibility': 'hidden',
        '-webkit-transform': 'translate3d(0, 0, 0)',
        '-moz-transform': 'translate3d(0, 0, 0)',
      },
    },
  },
});
